import React, { useEffect, useRef, useState } from 'react';
import $ from 'jquery';
import { registerLocale } from "react-datepicker";
import * as R from 'ramda';
import countriesList from 'iso-3166-1-alpha-2';
import fr from "date-fns/locale/fr";
import liendirect from './../../../assets/images/svg/049-family.svg';
import autres from './../../../assets/images/svg/051-parents.svg';
import { useDispatch, useSelector } from 'react-redux';
import {RegexFields} from '../../../constants/utils/regexFields';
import {DateWithModal} from '../../../_common/dateWithModal';
import { PostalCityInput } from "../../../_common/postalCityInput";
import countryTelData from 'country-telephone-data';
import {updateUserRepresentativeSelfcare} from '../../../actions/referent-api';

import parsePhoneNumber from 'libphonenumber-js';


export const EditReferent = ({ data, setIsEditing}) => {
    var countries = require("i18n-iso-countries");
    countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
    registerLocale("fr", fr);
    const dispatch = useDispatch();
    const [wasValidated, setWasValidated] = useState(false);

    //#region form
    const referentForm = useRef(null);
    const gender = { male: 2, female: 1 };
    const representativeType = {child: 1, parent:2, sibling:3, spouse:4, other:5};
    

    let initState = {...data};
    if(R.isNil(data.phoneNumber) || data.phoneNumber === ""){
        initState.phoneCountry = "FR";
        initState.countryCode = "33";
    }else{
        let phone = parsePhoneNumber(data.phoneNumber);
        initState.phoneNumber = phone.nationalNumber;
        initState.countryCode = phone.countryCallingCode;
        initState.phoneCountry = phone.country;
    }

    const [referentData, setReferentData] = useState(initState);

    useEffect(() => {
        $('[data-toggle="tooltip"]').tooltip();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    //#endregion
    return (
			<div className={"card border border-light p-4 mb-3"}>
				<form className="block" noValidate ref={referentForm}>
					<div className="form-row mb-3">
						<div className="form-group col-12 col-sm">
							<label className="h6 font-weight-bolder my-auto" htmlFor={"Email"}>
								Email
							</label>
							<input
								type="email"
								className="form-control"
								id={"Email"}
								defaultValue={referentData.email}
								onChange={(event) => {
									setReferentData({ ...referentData, email: event.target.value });
								}}
								pattern={RegexFields.email}
							/>
						</div>
					</div>

					<div className="form-group container-copy">
						<label className="h6 font-weight-bolder my-auto" htmlFor="phoneNumberInput">
							Numéro de portable
						</label>
						<div className="input-group mb-0">
							{/* <select className="custom-select rounded container-tiny mr-2" id={"phonecode"} tabIndex={-98} value={referentData.countryCode} onChange={(event) => {
                            setReferentData({ ...referentData, countryCode: event.target.value });
                        }}>
                            {
                                Object.keys(countriesList.getData()).map((country, index) => {
                                    let dialCode = countryTelData.allCountries[countryTelData.iso2Lookup[country.toLowerCase()]].dialCode;
                                    return (
                                        <option key={index} value={'+' + dialCode}>{countries.getName(country, "fr", {select: "official"})} (+{dialCode})</option>
                                    );
                                })
                            }
                        </select> */}

							<select
								className="custom-select rounded container-tiny mr-2"
								id={"phonecode"}
								tabIndex={-98}
								value={referentData.countryCode}
								onChange={(event) => {
									let pc = countryTelData.allCountryCodes[event.target.value][0].toUpperCase();
									setReferentData({ ...referentData, countryCode: event.target.value, phoneCountry: pc });
								}}>
								{countryTelData.allCountries.map((country, index) => {
									let dialCode = country.dialCode;
									return (
										<option key={index} value={dialCode}>
											{countries.getName(country.iso2, "fr", { select: "official" })} (+{dialCode})
										</option>
									);
								})}
							</select>
							<input
								type="tel"
								className="form-control rounded"
								id="phoneNumberInput"
								value={!R.isNil(referentData.phoneNumber) && parsePhoneNumber(referentData.phoneNumber, referentData.phoneCountry) !== undefined ? parsePhoneNumber(referentData.phoneNumber, referentData.phoneCountry).formatNational() : referentData.phoneNumber}
								aria-describedby="telephoneHelpBlock"
								onChange={(e) => {
									document.getElementById("phoneNumberInput").setCustomValidity("");
									setReferentData({ ...referentData, phoneNumber: e.target.value });
								}}
							/>

							{/* <input required type="tel" className="form-control rounded" id={"phone"} placeholder="00 00 00 00 00" value={referentData.phoneNumber} aria-describedby="telephoneHelpBlock"
                            onInput={(e) => {
                                e.preventDefault();
                                e.target.value = e.target.value.replace(/ /g, '');                                
                                var number = referentData.countryCode === "+33" ? e.target.value.replace(/\B(?=(\d{2})+(?!\d))/g, " ") : e.target.value.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                                setReferentData({ ...referentData, phoneNumber: number.replace(/\B(?=(\d{3})+(?!\d))/g, " ") });
                            }} /> */}
						</div>
					</div>

					<div className="form-inline mb-3">
						<div className="custom-control custom-radio custom-control-inline mr-6">
							<input
								required
								type="radio"
								id={"Madame"}
								name="SexMadameMonsieur"
								className="custom-control-input"
								defaultChecked={referentData.gender === gender.female}
								onClick={(e) => {
									setReferentData({ ...referentData, gender: gender.female });
								}}
							/>
							<label className="custom-control-label" htmlFor={"Madame"}>
								Madame
							</label>
						</div>
						<div className="custom-control custom-radio custom-control-inline">
							<input
								type="radio"
								id={"Monsieur"}
								name="SexMadameMonsieur"
								className="custom-control-input"
								defaultChecked={referentData.gender === gender.male}
								onClick={(e) => {
									setReferentData({ ...referentData, gender: gender.male });
								}}
							/>
							<label className="custom-control-label" htmlFor={"Monsieur"}>
								Monsieur
							</label>
						</div>
					</div>
					<div className="form-row">
						<div className="form-group col-12 col-sm-6 col-xl">
							<label className="h6 font-weight-bolder my-auto" htmlFor={"Prenom"}>
								Prénom
							</label>
							<input
								required
								type="text"
								className="form-control"
								id={"Prenom"}
								defaultValue={referentData.firstName}
								onChange={(e) => {
									e.preventDefault();
									setReferentData({ ...referentData, firstName: e.target.value });
								}}
								pattern={RegexFields.nameWithoutNumbers}
							/>
						</div>
						<div className="form-group col-12 col-sm-6 col-xl">
							<label className="h6 font-weight-bolder my-auto" htmlFor={"Nom"}>
								Nom
							</label>
							<input
								required
								type="text"
								className="form-control"
								id={"Nom"}
								defaultValue={referentData.lastName}
								onChange={(e) => {
									e.preventDefault();
									setReferentData({ ...referentData, lastName: e.target.value });
								}}
								pattern={RegexFields.nameWithoutNumbers}
							/>
						</div>

						<div className="form-group col-12 col-sm col-lg-auto col-xl">
							<label className="h6 font-weight-bolder my-auto" htmlFor={"naissance"}>
								Date de naissance
							</label>
							<DateWithModal isRequired={true} selectedDate={referentData.birthDate} setSelectedDate={(d) => setReferentData({ ...referentData, birthDate: d })} />
						</div>
					</div>
					<div className="form-row">
						<div className="form-group col-12 col-sm">
							<label className="h6 font-weight-bolder my-auto" htmlFor={"Adresse"}>
								Adresse
							</label>
							<input
								required
								type="text"
								className="form-control"
								id={"Adresse"}
								defaultValue={referentData.address.addressLine1}
								onChange={(event) => {
									setReferentData({ ...referentData, address: { ...referentData.address, addressLine1: event.target.value } });
								}}
							/>
						</div>
					</div>
					<div className="form-row">
						<PostalCityInput
							postalCode={referentData.address.postalCode}
							city={referentData.address.city}
							onChange={(updatedAddress) => setReferentData({ ...referentData, address: { ...referentData.address, postalCode: updatedAddress.postalCode, city: updatedAddress.city } })}
							hasWrapper={false}
							country={referentData.address.country}
							customClasses={{ city: "form-group col-12 col-sm col-xl", postalCode: "form-group col-12 col-sm col-xl" }}
						/>
						{/* <div className="form-group col-12 col-sm col-xl">
							<label className="h6 font-weight-bolder my-auto" htmlFor={"Postal"}>
								Code Postal
							</label>
							{referentData.address.country === null || referentData.address.country === "FR" || referentData.address.country === "GF" || referentData.address.country === "PF" || referentData.address.country === "TF" ? (
								<input
									required
									type="text"
									className="form-control"
									id={"Postal"}
									value={referentData.address.postalCode}
									onChange={(event) => {
										setReferentData({ ...referentData, address: { ...referentData.address, postalCode: event.target.value } });
									}}
									pattern={RegexFields.frenchZipCode}
								/>
							) : (
								<input
									required
									type="text"
									className="form-control"
									id={"Postal"}
									value={referentData.address.postalCode}
									onChange={(event) => {
										setReferentData({ ...referentData, address: { ...referentData.address, postalCode: event.target.value } });
									}}
								/>
							)}
						</div>
						<div className="form-group col-12 col-sm col-xl">
							<label className="h6 font-weight-bolder my-auto" htmlFor={"Ville"}>
								Ville
							</label>
							<input
								required
								type="text"
								className="form-control"
								id={"Ville"}
								defaultValue={referentData.address.city}
								onChange={(event) => {
									setReferentData({ ...referentData, address: { ...referentData.address, city: event.target.value } });
								}}
								pattern={RegexFields.nameWithoutNumbers}
							/>
						</div> */}
					</div>
					<div className="form-row">
						<div className="form-group col-12 col-sm col-xl">
							<label className="h6 font-weight-bolder my-auto" htmlFor={"naturalite"}>
								Pays *
							</label>
							<select
								className="custom-select"
								id={"naturalite"}
								tabIndex={-98}
								defaultValue={referentData.address.country}
								onChange={(event) => {
									setReferentData({ ...referentData, address: { ...referentData.address, country: event.target.value } });
								}}>
								{Object.keys(countriesList.getData()).map((country, index) => {
									return (
										<option key={index} value={country}>
											{countries.getName(country, "fr", { select: "official" })}
										</option>
									);
								})}
							</select>
						</div>
					</div>
					<div className="form-group">
						<label className="h6 font-weight-bolder" htmlFor={"ref"}>
							Vous êtes:
						</label>
						{/* {
                        data.createdByRepresentative ? 
                            <label className="h6 font-weight-bolder" htmlFor={"ref"}>Vous êtes:</label>
                        :
                            <label className="h6 font-weight-bolder" htmlFor={"ref"}>Le mandataire est pour vous:</label>
                    } */}

						<div className="form-row">
							<div className="form-group col-12 col-sm mb-2">
								<div
									className={"card px-3 py-2 border-faded text-capitalize picker-card flex-row align-items-center" + (referentData.representativeType !== representativeType.other ? " active" : "")}
									name={"ref"}
									onClick={() => {
										setReferentData({ ...referentData, isLienFamilialDirect: true, representativeType: undefined });
									}}>
									<img className="img-fluid my-auto mb-2 h-5 w-5 py-1" src={liendirect} alt="lien familial direct" />
									<h2 className="h6 font-weight-bolder ml-2 pl-1 mb-0 text-uppercase">lien familial direct</h2>
								</div>
							</div>
							<div className="form-group col-12 col-sm mb-2">
								<div
									className={"card px-3 py-2 border-faded text-capitalize picker-card flex-row align-items-center" + (referentData.representativeType === representativeType.other ? " active" : "")}
									name={"ref"}
									onClick={() => {
										setReferentData({ ...referentData, representativeType: representativeType.other });
									}}>
									<img className="img-fluid my-auto mb-2 h-5 w-5 py-1" src={autres} alt="autres" />
									<h2 className="h6 font-weight-bolder ml-2 pl-1 mb-0 text-uppercase">autres</h2>
								</div>
							</div>
						</div>
						{referentData.representativeType !== representativeType.other ? (
							<div className="form-group">
								<label className="h6 font-weight-bolder text-uppercase" htmlFor="processus">
									TYPE DE lien
								</label>
								<div className="form-inline mb-3">
									<div
										className="custom-control custom-radio custom-control-inline"
										onClick={() => {
											setReferentData({ ...referentData, representativeType: representativeType.child });
										}}>
										<input required type="radio" id="FilsFille" name="relationship" className="custom-control-input" defaultChecked={referentData.representativeType === representativeType.child} />
										<label className="custom-control-label" htmlFor="FilsFille">
											Fils/Fille
										</label>
									</div>
									<div
										className="custom-control custom-radio custom-control-inline"
										onClick={() => {
											setReferentData({ ...referentData, representativeType: representativeType.parent });
										}}>
										<input type="radio" id="Parent" name="relationship" className="custom-control-input" defaultChecked={referentData.representativeType === representativeType.parent} />
										<label className="custom-control-label" htmlFor="Parent">
											Parent
										</label>
									</div>
									<div
										className="custom-control custom-radio custom-control-inline"
										onClick={() => {
											setReferentData({ ...referentData, representativeType: representativeType.sibling });
										}}>
										<input type="radio" id="FrèreSoeur" name="relationship" className="custom-control-input" defaultChecked={referentData.representativeType === representativeType.sibling} />
										<label className="custom-control-label" htmlFor="FrèreSoeur">
											Frère/Soeur
										</label>
									</div>
									<div
										className="custom-control custom-radio custom-control-inline"
										onClick={() => {
											setReferentData({ ...referentData, representativeType: representativeType.spouse });
										}}>
										<input type="radio" id="Conjoint" name="relationship" className="custom-control-input" defaultChecked={referentData.representativeType === representativeType.spouse} />
										<label className="custom-control-label" htmlFor="Conjoint">
											Conjoint
										</label>
									</div>
								</div>
							</div>
						) : (
							""
						)}
						<div className={"invalid-feedback alert-danger alert" + (referentData.representativeType === undefined && wasValidated === true ? " d-block" : "")}>Veuillez choisir une option</div>
					</div>

					<div className="form-row text-right mt-4 mx-auto justify-content-end">
						<React.Fragment>
							<button
								type="button"
								className="btn btn-light text-muted px-3 mr-auto"
								onClick={() => {
									setIsEditing(false);
								}}>
								Annuler
							</button>
						</React.Fragment>
						<button
							type="button"
							className="btn btn-info"
							onClick={async (event) => {
								event.preventDefault();

								let internationalPhoneNumber = null;
								if (!R.isNil(referentData.phoneNumber) && !R.isEmpty(referentData.phoneNumber)) {
									internationalPhoneNumber = parsePhoneNumber(referentData.phoneNumber, referentData.phoneCountry);
									if (!internationalPhoneNumber.isValid()) {
										document.getElementById("phoneNumberInput").setCustomValidity("Le numéro de téléphone n'est pas valide.");
									}
								}
								if (referentForm.current.checkValidity()) {
									dispatch(updateUserRepresentativeSelfcare(referentData.id, { ...referentData, phoneNumber: internationalPhoneNumber?.number })).then(() => setIsEditing(false));
								}
								if (!R.isNil(referentForm) && !R.isNil(referentForm.current) && !R.isNil(referentForm.current.classList)) {
									referentForm.current.classList.add("was-validated");
								}
								setWasValidated(true);
							}}>
							Sauvegarder
						</button>
					</div>
				</form>
			</div>
		);
}